import React from "react";

function Color_Flat_UI() {
  return (
    <div>
      <h1>Color_Flat_UI Component</h1>
      <p>This is the Color Flat UI tutorial page content.</p>
    </div>
  );
}

export default Color_Flat_UI;
